// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// utils
import { size } from 'polished'

export const FunctionWrapper = styled.div<{
  width: number
  height: number
  hasLink: boolean
}>`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: ${({ hasLink }) => (hasLink ? 'pointer' : 'default')};
  border-radius: 6px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  padding: 16px;
  height: ${({ height }) => height}px;
  background-color: ${colors.white100};

  svg {
    min-width: 50px;

    ${size('50px')};
  }
`

export const FunctionContent = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 16px;
  overflow: hidden;
  font-size: 14px;

  > div {
    overflow: auto;
  }
`

export const FunctionImage = styled.img`
  width: 80px;
  height: 80px;
`

export const FunctionTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
`
